import { downloadCsv } from '../../../lib/downloadBlob';
import { reportMetricDefinitions } from './catalog';
import { reportMetricLabel } from './format';
import type { ReportRequest, ReportResponse } from './model';
import { reportDisplayMetrics } from './reportRequest';

const reportExportFilename = 'report-export.csv';

export function canExportReport(response?: ReportResponse) {
  const meta = response?.highCardinalityReportMeta;
  if (meta?.downloadUrl?.trim()) return true;
  if (meta?.limited) return Boolean(meta.downloadUrl?.trim());
  return Boolean(response?.report.length);
}

export function createReportCsv(request: ReportRequest, response: ReportResponse) {
  const metrics = reportDisplayMetrics(request);
  const rows = response.report.map((row) =>
    metrics.map((metric) => row[reportMetricDefinitions[metric].field] ?? ''),
  );

  return [metrics.map(reportMetricLabel), ...rows]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n');
}

export function exportReportCsv(request: ReportRequest, response: ReportResponse) {
  const downloadUrl = response.highCardinalityReportMeta?.downloadUrl?.trim();
  if (downloadUrl) {
    window.open(downloadUrl, '_blank', 'noopener,noreferrer');
    return;
  }
  if (response.highCardinalityReportMeta?.limited) return;

  downloadCsv(createReportCsv(request, response), reportExportFilename);
}

function escapeCsvValue(value: string | number | boolean) {
  const text = String(value);
  const safeText = /^[\t\r=+\-@]/.test(text) ? `'${text}` : text;
  return /[",\r\n]/.test(safeText) ? `"${safeText.replaceAll('"', '""')}"` : safeText;
}
